import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../shared/modal.service';
import { SecurityService } from '../../shared/security.service';
import { CustomerSelectionModalDialogComponent } from '../customer-selection-modal/customer-selection-modal-dialog.component';
import { CustomerSupportService } from '../services/customer-support.service';

@Component({
    selector: 're-customer-selection',
    templateUrl: './customer-selection.component.html',
    styleUrls: ['./customer-selection.component.scss'],
    standalone: false
})
export class CustomerSelectionComponent implements OnInit {

  constructor(private route:Router, private securityService: SecurityService, private modalService: ModalService, private customerSupportService: CustomerSupportService) { }

  async ngOnInit() {


    let isAdmin = await this.securityService.isUserManagementCorporateAdmin().toPromise();
    let customer = this.customerSupportService.getSelectedCustomer();


    //has the customer admin rtole assgined and the customer has been selected and stored in localStorage for display, proceed
    //this shoud not normally be run. since after customer seleftion the user is redirected to the /users screen
    //if for some reason, the user navigated to this page, with a customer previously selected, we redirect the user to the /users screen
    if (isAdmin && customer) {
      this.route.navigateByUrl("/users");
      return;
    } 
    //let customer = this.customerSupportService.loadCustomer();
    //if (customer) {
    //  window.location.href = "/users";
    //  return;
    //}
 
    let dialog = CustomerSelectionModalDialogComponent.show(this.modalService);



  }

}
